export enum LoanMerchantName {
  TBI = 'tbi',
  ALPHA = 'alpha',
  PIRAEUS = 'piraeus'
}

export interface LoanInfoResult {
  total: number
  installment: number
  interestPercentage: string
  loanFee: number
  monthlyAmount?: number
  monthlyInstallment?: number
  maxInstallments?: number
  interest?: number
}

export interface SantanderInstallmentAnalysis {
  mouthQuote: string
  expirationDate: null | number
  capital: string
  quoteId: string
  monthInterest: string
}

export interface SantanderInstallmentSummary {
  installmentCount: string
  installmentAmount: string
}

export interface SantanderInstallmentGeneralInfo {
  feesAmount: string
  insuranceLifeAmount: string
  insuranceAmount: string
  insuranceEmploymentAmount: string
  insuranceDamageAmount: string
  feesPercentage: string
}

export interface SantanderLoanInstallments {
  installmentAnalysis: SantanderInstallmentAnalysis[]
  installmentSummary: SantanderInstallmentSummary[]
  generalInfo: SantanderInstallmentGeneralInfo
}

export interface LoanTargetResult {
  targetUrl: string
}

export interface SantanderTargetResult {
  url: string
}
